import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import  from "../../../../components/CustomModal/CustomModal";
// import CustomButton from "../../../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { AppColors } from "../../../../util/AppColors";

// Import actions
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";
import {
  createDevice,
  deleteDevice,
  getDevices,
  updateDevice,
} from "../../../../redux/reducers/deviceSlice";

function Devices() {
  const dispatch = useDispatch();
  const { devices, loading } = useSelector((state) => state.device);
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ name: "" });
  const [editForm, setEditForm] = useState({ name: "" });

  useEffect(() => {
    dispatch(getDevices());
  }, [dispatch]);

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const facilityId = devices[deleteIndex].facilityId;
    dispatch(deleteDevice(facilityId)).then(() => {
      handleDelModClose();
    });
  };

  const handleEdit = (index) => {
    const selectedDevice = devices[index];
    setForm({ name: selectedDevice.name });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleAdd = () => {
    dispatch(createDevice({ name: form.name, type: "Devices" })).then(() => {
      dispatch(getDevices());
      setForm({ name: "" });
      setEditIndex(null);
      setOpenDrawer(false);
    });
  };

  const handleUpdate = () => {
    const facilityId = devices[editIndex].facilityId;
    dispatch(
      updateDevice({
        id: facilityId,
        name: form.name,
        type: "Devices",
      })
    ).then(() => {
      dispatch(getDevices());
      setForm({ name: "" });
      setEditIndex(null);
      setOpenDrawer(false);
    });
  };

  const handleDelete = (index) => {
    const facilityId = devices[index].facilityId;
    dispatch(deleteDevice(facilityId));
  };

  const filteredRows = devices.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, device) => {
    dispatch(
      updateDevice({
        id: device?.facilityId,
        name: device?.name,
        type: "Devices",
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getDevices());
    });
  };

  return (
    <Box>
      {/* Top section */}
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <div className="w30Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearch(e.target.value)}
                      value={search}
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={() => setOpenDrawer(true)}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
          <Typography className="font-medium fs12 gray28">
            Total Devices: {filteredRows?.length}
          </Typography>
        </Container>
      </TopBar>

      {/* Table */}
      <CustomTable
        grey
        columns={[
          "sNo",
          "deviceName",
          "newStatus",
          "createdBy",
          "createdDate",
          "actions",
        ]}
        datas={filteredRows?.map((row, index) => ({
          sNo: index + 1,
          deviceName: row?.name,
          newStatus: (
            <div>
              <div>
                <CustomSwitch
                  value={row?.status}
                  onChange={(e) => handleChangeSwitch(e?.target?.value, row)}
                  greenToRed
                />
              </div>
              <div>{row?.status ? "Active" : "Under Maintenance"}</div>
            </div>
          ),
          createdBy: row?.userName || "-",
          createdDate: new Date(row?.createdDate)?.toLocaleDateString(),
          actions: (
            <div>
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEdit(index)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => {
                  setDeleteIndex(index);
                  setDelModVisible(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        }))}
      />

      {/* Drawer for adding new device */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Device" : "Create Device"}
            </Typography>
            <IconButton onClick={() => setOpenDrawer(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Device Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={editIndex !== null ? handleUpdate : handleAdd}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Edit Dialog */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Devices;
